import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 7a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 10a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-10-5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.755 7.15l-6.147 3.276c.351.359.583.834.632 1.363l6.112-3.257a2.242 2.242 0 01-.597-1.382zM9.24 12.21a2.243 2.243 0 01-.632 1.364l6.147 3.275a2.242 2.242 0 01.597-1.381L9.24 12.211z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 24a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-24-12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.025 26.013L32 34m-.025-19.987l-15.95 7.974"
  }))
};
export var Shareaos = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});